export function F8LoadingError(): void {
  window.parent.postMessage({ type: "f8_failed_loading" }, "*");
  document.documentElement.style.height = "0px";
  document.documentElement.style.overflow = "hidden";
  document.body.style.height = "0px";
  document.body.style.overflow = "hidden";
}
